/* eslint-disable vue/multi-word-component-names */

<template>
  <nav class="nav" role="navigation">
    <div class="nav__back-button" @click="removeActive">
      <img
        src="../assets/site-icons/rightarrow-icon.svg"
        alt="red right arrow to close mobile navigation"
      />
    </div>
    <router-link to="/" class="nav__logo-link">
      <img
        src="../assets/site-icons/logo.svg"
        alt="mjccreative logo"
        class="nav__logo"
      />
    </router-link>
    <ul class="nav__container">
      <li class="nav__link-container" @click="removeActive">
        <router-link to="/" class="nav__link" exact>home</router-link>
      </li>
      <li class="nav__link-container" @click="removeActive">
        <router-link to="/collection/print" class="nav__link" exact rel="canonical"
          >print</router-link>
      </li>
      <li class="nav__link-container" @click="removeActive">
        <router-link to="/collection/branding" class="nav__link" exact rel="canonical"
          >branding</router-link>
      </li>
      <li class="nav__link-container" @click="removeActive">
        <router-link to="/collection/digital" class="nav__link" exact rel="canonical"
          >ux/ui/digital</router-link>
      </li>
      <li class="nav__link-container" @click="removeActive">
        <router-link to="/collection/fun" class="nav__link" exact rel="canonical"
          >just for fun</router-link>
      </li>
      <li class="nav__link-container" @click="removeActive">
        <router-link
          to="/collection/illustration" class="nav__link nav__link--new" exact rel="canonical"
          >illustration</router-link>
      </li>
    </ul>
    <div class="overlay" @click="removeActive"></div>
  </nav>
</template>

<script type="text/javascript">
export default {
  methods: {
    removeActive: function() {
      var site = document.getElementById("site__wrapper");
      site.classList.remove("active");
    }
  }
};
</script>

<style lang="scss" scoped>
@use "../assets/scss/_siteVariables" as *;

.nav {
  width: 236px;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px 20px 0px 20px;
  position: absolute;
  top: 0;
  left: -236px;
  z-index: 2;
  background: var(--white);
  @media only screen and (min-width: 1000px) {
    padding: 66px 0px 0px 0px;
    position: relative;
    left: 0;
  }
  &__logo-link {
    display: none;
    @media only screen and (min-width: 1000px) {
      display: block;
    }
  }
  &__logo {
    @media only screen and (min-width: 1000px) {
      display: block;
      max-width: 160px;
      max-height: 160px;
    }
  }
  //controls nav container
  &__container {
    margin: 5px 0 0;
    padding: 0;
    list-style-type: none;
    display: flex;
    flex-direction: column;
    justify-content: start;
    @media only screen and (min-width: 1000px) {
      margin: 36px 0 0;
    }
  }
  &__link {
    color: var(--darkest-grey);
    font-size: 24px;
    @media only screen and (min-width: 1000px) {
      font-size: 22px;
    }
    text-decoration: none;
    &--cs::after {
      content: "COMING SOON";
      font-size: 9px;
      top: -10px;
      position: relative;
      left: 2px;
    }
    &--new::after {
      content: "NEW";
      font-size: 9px;
      top: -10px;
      position: relative;
      left: 2px;
      color: $main-red;
    }
    &:hover {
      color: var(--accent);
    }
    //controls li tags
    &-container {
      padding: 6px 0;
      @media only screen and (min-width: 1000px) {
        padding: 3px 0;
      }
    }
  }
  &__back-button {
    width: 15px;
    height: 24px;
    align-self: flex-end;
    @media only screen and (min-width: 1000px) {
      display: none;
    }
  }
  //vue basic active class
  .router-link-active {
    color: var(--accent);
    font-weight: bold;
  }
  .disabled {
    cursor: not-allowed;
    pointer-events: none;
    color: $mid-grey;
  }
}
.active {
  .nav {
    .overlay {
      background-color: rgba(0, 0, 0, 0.3);
      position: absolute;
      width: 100vw;
      top: 0;
      left: 236px;
      bottom: 0;
      right: 0;
      z-index: 1;
    }
  }
}
</style>
